import type { Read } from '@signalvote/data';

/** A read's data once it answered, or undefined while it loads, has not run, or could not answer. */
export function answered<T>(read: Read<T>): T | undefined {
  return read.status === 'ready' || read.status === 'placeholder' ? read.data : undefined;
}

/** Why a reports read (the list, the deadlines, a report's preview or send status) has nothing to show, in words, or null when they answered or are loading. */
export function reportsUnreadyMessage(subject: string, read: { status: string }): string | null {
  if (read.status === 'failed') return `Couldn't load your ${subject}. Refresh to try again.`;
  if (read.status === 'offline') return `You're offline, so your ${subject} can't load.`;
  return null;
}
